import React from 'react';
import { connect } from 'react-redux';

class GuideHighlight extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { ref: React.createRef() };
  }

  componentDidUpdate({ isOpen: wasOpen, addMarker }) {
    const { isOpen, side = 'r', i } = this.props;
    const { ref } = this.state;

    if (isOpen && !wasOpen) {
      const padding = 8;
      const rect = ref.current.getBoundingClientRect();
      addMarker({
        width: rect.width + 2 * padding,
        height: rect.height + 2 * padding,
        top: rect.top - padding,
        left: rect.left - padding,
        side,
        i,
      });
    }
  }

  render() {
    const {
      children,
      tag = 'div',
      className = '',
      isOpen,
    } = this.props;
    const { ref } = this.state;
    const Tag = tag;

    return (
      <Tag className={`guide-highlight ${className}`} data-open={isOpen} ref={ref}>
        {children}
      </Tag>
    );
  }
}

const mapStateToProps = (store) => ({
  isOpen: store.guide.isOpen,
});

const mapDispatchToProps = (dispatch, { id }) => ({
  addMarker: (marker) => dispatch({ type: 'ADD_GUIDE_MARKER', id, marker }),
});

export default connect(mapStateToProps, mapDispatchToProps)(GuideHighlight);
